<script>
  import CrossIcon from "../../../Common/Icons/CrossIcon.svelte";

  // Props
  export let filterName = "";
  export let remove = null;
</script>

<div class="reports-search-results-filter">
  <button class="remove-filter-btn" on:click|preventDefault={remove || {}}>
    <CrossIcon />
  </button>
  <p>{filterName}</p>
</div>

<style>
  .reports-search-results-filter {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    margin-right: 25px;
  }

  .reports-search-results-filter p {
    font-family: "Segoe UI", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #4a4a4a;
  }

  .remove-filter-btn {
    border: none;
    background: transparent;
    cursor: pointer;
    color: #4a4a4a;
    margin-right: 8px;
  }
</style>
